import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Box, Hide, Link, OutlineButton } from 'roo-ui/components';

const StyledOutlineButton = styled(OutlineButton)`
  &:hover {
    color: ${themeGet('colors.white')};
  }
`;

const ResponsiveButtonLink = ({ as, href, onClick, text, to, ...props }) => (
  <Box {...props}>
    <Hide xs>
      <Link as={as} href={href} onClick={onClick} to={to} data-testid="desktop-link">
        {text}
      </Link>
    </Hide>

    <Hide sm md lg>
      <StyledOutlineButton as={as} href={href} onClick={onClick} to={to} variant="primary" width={[1, 'inherit']} data-testid="mobile-link">
        {text}
      </StyledOutlineButton>
    </Hide>
  </Box>
);

ResponsiveButtonLink.propTypes = {
  as: PropTypes.oneOfType([PropTypes.func, PropTypes.node, PropTypes.string, PropTypes.object]),
  href: PropTypes.string,
  onClick: PropTypes.func,
  text: PropTypes.string.isRequired,
  to: PropTypes.string,
};

ResponsiveButtonLink.defaultProps = {
  as: 'a',
  href: null,
  onClick: noop,
  to: null,
};

export default ResponsiveButtonLink;
